import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import DemoRegistration from './components/DemoRegistration'
import { initTheme } from './theme'
import './index.css'

// Runs before first paint so there's no flash of the wrong theme.
initTheme()

const root = ReactDOM.createRoot(document.getElementById('root'))
const isPublicDemoPage = window.location.pathname.startsWith('/demo')

root.render(
  <React.StrictMode>
    {isPublicDemoPage ? <DemoRegistration /> : <App />}
  </React.StrictMode>
)
